<div class="size-full">
  @if (singleMode()) {
    <div class="relative ion-activatable ripple-parent size-full">
      <div
        [class]="'size-full border border-medium border-dashed bg-light/20 relative ' + borderRadiusClass()"
        [ngClass]="{
          'border-primary': isDragging(),
          'border-none': singleEntry(),
        }"
      >
        @if (singleEntry(); as entry) {
          <img [src]="entry.url" [alt]="entry.url" [class]="borderRadiusClass() + ' size-full object-cover'" />
          @if (entry.state.type === "error" || entry.state.type === "loading") {
            <div [class]="'absolute left-0 top-0 size-full bg-medium opacity-70 ' + borderRadiusClass()"></div>
          }
          <div class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform flex flex-col">
            <div class="flex justify-center px-2">
              @if (entry.state.type === "loading") {
                <ion-spinner class="!h-10 !w-10" />
              }
            </div>
          </div>
        }
        <div
          [class]="
            'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform flex flex-col items-center justify-center gap-1.5 ' +
            borderRadiusClass()
          "
        >
          @if (isDragging()) {
            <ion-icon class="" size="large" name="cloud-upload-outline"></ion-icon>
          } @else if (!singleEntry()) {
            <ion-icon name="image-outline" class="mb-1 mt-2 opacity-60" size="large" color="medium" />
            @if (showLabel()) {
              <ion-label color="medium" class="text-md text-center">
                {{ labelTr() | translate }}
              </ion-label>
            }
          }
        </div>
      </div>
      <ion-ripple-effect [class]="borderRadiusClass()"></ion-ripple-effect>

      <mtjr-dropzone
        (dragover)="onDragOver()"
        [borderRadiusClass]="borderRadiusClass()"
        (dragleave)="onDragLeave()"
        class="size-full absolute top-0 left-0"
        (click)="filePicker2.click()"
      >
        <input
          #filePicker2
          type="file"
          fileInput
          (selectionChange)="onFilesPicked($event)"
          [multiple]="false"
          accept="image/*"
        />
      </mtjr-dropzone>
      @if (singleEntry(); as entry) {
        @if (entry.state.success) {
          <ion-button
            class="absolute top-2 left-2 bg-light/50 !rounded-full !z-100"
            color="danger"
            fill="clear"
            shape="round"
            (click)="remove(entry); $event.stopPropagation()"
          >
            <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
          </ion-button>
        } @else if (entry.state.type === "error") {
          <div
            [class]="
              'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform flex flex-row items-center justify-center gap-2 ' +
              borderRadiusClass() +
              ' bg-white/20 px-4 py-2'
            "
          >
            <ion-button color="warning" fill="outline" role="button" shape="round" (click)="retry(entry)">
              <ion-icon slot="icon-only" name="refresh-circle" size="large"></ion-icon>
            </ion-button>
            <ion-button
              class="bg-danger !rounded-full !z-100"
              color="danger"
              fill="clear"
              shape="round"
              (click)="remove(entry); $event.stopPropagation()"
            >
              <ion-icon slot="icon-only" class="text-white" name="trash-outline"></ion-icon>
            </ion-button>
          </div>
        }
      }
    </div>
  } @else {
    <div class="grid w-full grid-cols-3 gap-2 py-2 sm:grid-cols-3 md:grid-cols-5">
      @for (entry of uploadEntries(); track entry.url) {
        <div [class]="'relative flex aspect-square size-full flex-col  bg-medium/50 ' + borderRadiusClass()">
          <img
            [src]="entry.url"
            [alt]="entry.url"
            [class]="'h-full !border border-solid border-medium object-cover ' + borderRadiusClass()"
          />
          @if (entry.state.type === "error" || entry.state.type === "loading") {
            <div [class]="'absolute left-0 top-0 size-full bg-medium opacity-70 ' + borderRadiusClass()"></div>
          }
          <div
            class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform flex items-center justify-center gap-2"
          >
            @if (entry.state.type === "loading") {
              <ion-spinner class="!h-10 !w-10" />
            }
            @if (entry.state.type === "error") {
              <div
                [class]="
                  'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform flex flex-row items-center justify-center gap-2 ' +
                  borderRadiusClass() +
                  ' bg-white/20 px-3 py-2'
                "
              >
                <ion-button color="warning" fill="outline" role="button" shape="round" (click)="retry(entry)">
                  <ion-icon slot="icon-only" name="refresh-circle" size="large"></ion-icon>
                </ion-button>
                <ion-button
                  class="bg-danger !rounded-full !z-100"
                  color="danger"
                  fill="clear"
                  shape="round"
                  (click)="remove(entry); $event.stopPropagation()"
                >
                  <ion-icon slot="icon-only" class="text-white" name="trash-outline"></ion-icon>
                </ion-button>
              </div>
            }
          </div>
          @if (entry.state.success) {
            <ion-button
              class="absolute top-1 left-1 bg-light/50 !rounded-full !z-100"
              color="danger"
              fill="clear"
              shape="round"
              (click)="remove(entry); $event.stopPropagation()"
            >
              <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
            </ion-button>
          }
        </div>
      }

      <div class="relative ion-activatable ripple-parent">
        <div
          [class]="
            'flex aspect-square size-full  border border-medium border-dashed flex-col items-center justify-center bg-light/10 ' +
            borderRadiusClass()
          "
          [ngClass]="{
            'border-primary': isDragging(),
          }"
        >
          @if (isDragging()) {
            <ion-icon class="" size="large" name="cloud-upload-outline"></ion-icon>
          } @else {
            <ion-icon name="image-outline" class="mb-1 mt-2 opacity-60" size="large" color="medium" />
            <ion-label color="medium">{{ labelTr() | translate }}</ion-label>
          }
        </div>
        <ion-ripple-effect [class]="borderRadiusClass()"></ion-ripple-effect>

        <mtjr-dropzone
          (dragover)="onDragOver()"
          (dragleave)="onDragLeave()"
          [borderRadiusClass]="borderRadiusClass()"
          class="size-full absolute top-0 left-0"
          (click)="filePicker.click()"
        >
          <input
            #filePicker
            type="file"
            fileInput
            (selectionChange)="onFilesPicked($event)"
            [multiple]="true"
            accept="image/*"
          />
        </mtjr-dropzone>
      </div>
    </div>
  }
</div>
